import * as React from 'react';
import styled from "styled-components";
import img1 from "../assets/w_verbix.gif";
import img2 from "../assets/w_terra.gif";
import img3 from "../assets/w_periodismo.gif";
import img4 from "../assets/w_diccdelareal.gif";
import img5 from "../assets/w_hiszponline.gif";
import img6 from "../assets/w_jhonline.gif";
import img7 from "../assets/w_elpais.gif";
import img8 from "../assets/w_publintur.gif";
import img9 from "../assets/w_jezykwsieci.gif";
import img10 from "../assets/w_webmadrid.gif";
import img11 from "../assets/w_hispavista.gif";
import img12 from "../assets/w_learnalang.gif";
import img13 from "../assets/w_escolar.gif";

const SWww = styled.div`
  flex: 1;
  padding: 5px 20px;
  max-width: 100%;

.files-list {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.file-item {
  display: grid;
  grid-template-columns: 100px 20% auto;
  gap: 10px;  /* Adjust space between columns */
  align-items: start;
  margin-bottom: 15px;  /* Adjust space between rows */
  background-color: #f5f5f5; /* Light gray background */
  border: 1px solid #e0e0e0; /* Light gray border */
  border-radius: 5px; /* Optional: Adds rounded corners */
  padding: 5px;
}

.file-title-url {
  display: flex;
  flex-direction: column;
}

.file-title {
  margin-bottom: 5px;  /* Space between title and URL */
  font-weight: bold;
}
`;

function WwwList(props) {
  return (
    <div className="files-list">
    {props.data.map(item => (
        <div key={item.id} className="file-item">
            <img src={item.img} alt={item.name}/>
            <div className="file-title-url">
                <div className="file-title">{item.title}</div>
                <a href={item.url}>{item.url}</a>
            </div>
            <div dangerouslySetInnerHTML={{ __html: item.desc }} />
        </div>
    ))}
</div>
  );
}

const Www = () => {
  const data = [
    {
      id: "1",
      img: img1,
      title: "Verbix",
      url: "http://www.verbix.com",
      desc: "Verbix jest niezależną, niekomercyjną organizacją której celem jest promowanie i ochrona językowej różnorodności. Strona zawiera bazę koniugacji dla setek języków, od międzynarodowych i narodowych po regionalne czy nawet wymierające. Oczywiście wśród tych języków jest również <a href=\"http://www.verbix.com/languages/spanish.shtml\" target=\"_blank\">język hiszpański</a>.<br>Dodatkowo ze strony można pobrać <a href=\"http://www.verbix.com/windowsverbix/index.html\" target=\"_blank\">program</a> służący do odmiany czasowników (w dwóch wersjach: freeware i shareware). Niestety w wersji freeware zawiera on bazę czasowników ograniczoną do mało znanych języków, m.in. bez języka hiszpańskiego. Na szczęście <a href=\"http://www.verbix.com/languages/index.asp\" target=\"_blank\">wersji sieciowej</a> można używać bez ograniczeń."
    },
    {
      id: "2",
      img: img2,
      title: "Terra",
      url: "http://www.terra.es",
      desc: "Portal Terra jest hiszpańskojęzycznym odpowiednikiem naszego Onetu czy Wirtualnej Polski. Zawiera typowy zestaw serwisów i kanałów taki jak poczta, wiadomości, muzyka itp. Jedną z ciekawszych opcji jest <a href=\"http://www.terra.es/miciudad/\" target=\"_blank\">przewodnik</a> po hiszpańskich miastach, w którym można uzyskać informacje o restauracjach, kinach, aptekach itd. Portal jest międzynarodowy - ma m.in. wersję brazylijską, kolumbijską, amerykańską, panamską (w sumie 17)."
    },
    {
      id: "3",
      img: img3,
      title: "Periodismo",
      url: "http://www.periodismo.com",
      desc: "Periodismo jest serwisem grupującym teksty najciekawszych artykułów z największych hiszpańskojęzycznych gazet (m.in. z hiszpańskich <i>El Mundo</i> i <i>El País</i> czy argentyńskiego <i>La Naci&oacuten</i>). Ponadto zawiera odnośniki do stron najpopularniejszych gazet, czasopismo oraz stacji radiowych.<br>Ciekawą opcją jest możliwość zaprenumerowanie codziennego biuletynu emailowego, w którym przesyłane są linki do artykułów."
    },
    {
      id: "4",
      img: img4,
      title: "Diccionario de la Real Academia Española",
      url: "http://cultura.terra.es/cac/rae/",
      desc: "Słownik umieszczony w portalu Terra.es. Jest to słownik hiszpańsko-hiszpański z dużymi możliwościami wyszukiwania."
    },
    {
      id: "5",
      img: img5,
      title: "Hiszpania Online",
      url: "http://www.hiszpania-online.pl",
      desc: "Jest to portal o Hiszpanii - oddając głos autorom: \"Portal hiszpański jest dla wszystkich tych, których interesuje Hiszpania. Można znaleźć tu przede wszystkim Wirtualny Przewodnik po regionach Hiszpanii, porady i informacje potrzebne przy planowaniu podróży. Dla zainteresowanych danymi statystycznymi, historią, architekturą, rolnictwem czy malarstwem jest dział 'Kompendium Wiedzy'. Zawiera również informacje o literaturze - tłumaczenia wierszy poetów hiszpańskich, recenzje książek. Natomiast dla smakoszy i znawców kuchni śródziemnomorskiej - kącik kulinarny z przepisami oryginalnych potraw hiszpańskich.\""
    },
    {
      id: "6",
      img: img6,
      title: "Hiszpański On-line",
      url: "http://republika.pl/jezykhiszpanski1/",
      desc: "Strona ta ma na celu w sposób przystępny i szybki nauczyć Cię języka hiszpańskiego. Zawiera zarówno materiały z zakresu gramatyki, jak i słownictwo."
    },
    {
      id: "7",
      img: img7,
      title: "El Pais",
      url: "http://www.elpais.es",
      desc: "El Pais to jeden z największych hiszpańskich dzienników. Na tej stronie można znaleźć wszystko na temat tego co się dzieje na codzień w Hiszpanii. Jest tam mnóstwo aktualnych artykułów na temat polityki, ekonomii, kultury i sztuki, edukacji, nowoczesnej technologii itp."
    },
    {
      id: "8",
      img: img8,
      title: "Catalonia Tourist Guide",
      url: "http://www.publintur.es/defaultang.htm",
      desc: "Przewodnik po Katalonii - zawiera informacje praktyczne i wiadomości o ciekawych miejscach w Katalonii."
    },
    {
      id: "9",
      img: img9,
      title: "Język w sieci",
      url: "http://www.jezyk.waw.pl/list.php?lang=sp",
      desc: "Język w sieci to skatalogowany zbiór odnośników do różnych miejsc w internecie, które pomagają lepiej poznawać języki obce. Można wyszukiwać strony zaznaczając różne opcje np. strony tylko po polsku, strony z kursami do nauki języka hiszpańskiego, ze słownikami, z tekstami i ćwiczeniami, z gramatyką, z multimediami (audio lub video)."
    },
    {
      id: "10",
      img: img10,
      title: "WebMadrid",
      url: "http://www.webmadrid.com",
      desc: "Wszystko, co turysta powinien wiedzieć o Madrycie."
    },
    {
      id: "11",
      img: img11,
      title: "Hispavista",
      url: "http://www.hispavista.com",
      desc: "HispaVista to wyszukiwarka stron hiszpańskojęzycznych z całego świata. Zawiera typowy zestaw serwisów i kanałów."
    },
    {
      id: "12",
      img: img12,
      title: "Elementary Spanish",
      url: "http://www.learnalanguage.org/elemspan/",
      desc: "Wesoła i kolorowa strona w materiałami do nauki hiszpańskiego, strona dla dużych i małych."
    },
    {
      id: "13",
      img: img13,
      title: "Escolar",
      url: "http://www.escolar.com",
      desc: "Strona, która nie tylko uczy języka hiszpańskiego, ale również umożliwia naukę np. historii i matematyki w języku hiszpańskim. Zawiera dużo informacji o rzadko poruszanych dziedzinach języka hiszpańskiego jak reguły ortografii, sylaby czy interpunkcja."
    }
  ]

  return (
    <SWww>
      <h5>Strony WWW</h5>
      <WwwList data={data} />
    </SWww>
    )
};

export default Www;